/* eslint-disable no-undef */
import React from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { StyledModal } from "../../AttendeesModal/styles";
// import { Border } from "../../Journeys/styles";
import { CommonButtonPopup } from "../../ReportsV2/styles";
import { t } from "i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import LazyImage from "../../common/LazyImage/LazyImage";
import { ImageUrl } from "../../../utils/constants";

const Personalize = ({ showModal, onHide, /*history,onClick*/ fname}) => {
  window.console.log("hii")
  return (
    <StyledModal
      $width={"400px"}
      $height={"auto !important"}
      show={showModal}
      // onHide={onHide}
    >
      {/* Header */}
      {/* <Modal.Header style={{ background: "white", border: "none" }}>
        <CustomTitle>
          <div>
            <span>{t('Personalize Your Dashboard')}</span> */}
      {/* <span className="closeImage">
              <div onClick={onHide}>{AdminCloseIcon()}</div>
            </span> */}
      {/* </div>
        </CustomTitle>
      </Modal.Header> */}

      {/* <Border
        style={{
          width: "93%",
          background: "#EFEFEF",
          margin: "4px 16px 20px 16px",
        }}
      /> */}

      <Modal.Body style={{gap:'20px',display:'flex',flexDirection:'column',padding:'0px 16px', alignItems:'center',justifyContent:'center'}}>
        <LazyImage style={{width:'230px', padding:'16px 0 0'}} src={ImageUrl + "/images/onboarding.png"}/>

        <div className="text" style={{fontWeight:'700'}}>
          {t(`Hi ${fname}!`)}
        </div>
        <div className="text">
          {t(`Ready to make your wellness journey your own?`)}<br/>
          {t(`Let’s personalize your wellness pillars`)}
        </div>
      </Modal.Body>
 
      {/* Footer */}
      <Modal.Footer
        style={{
          borderTop: "none",
          display: "flex",
          gap: "12px",
          width: "100%",
        }}
      >
        <div style={{ display: "flex", gap: "12px", marginTop: "20px",width:'100%', justifyContent:'center' }}>
          <CommonButtonPopup
            height="40px"
            width="auto"
            onClick={onHide}
          >
            {t("Let’s get Started")}
          </CommonButtonPopup>
  
        </div>
      </Modal.Footer>  
    </StyledModal>
  );
};

Personalize.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onHide: PropTypes.func,
  challengeId:PropTypes.number,
  fname:PropTypes.string,
  history:PropTypes.object,
  onClick:PropTypes.func
};

export default withRouter(connect(null, null)(withTranslation()(Personalize)));
